import React, { useRef } from 'react';
import solvingen from '../assets/solvingen.png';
import upravia from '../assets/upravia.png';
import gestora from '../assets/gestora.png';
import ayde from '../assets/ayde.png';
import barlo from '../assets/barlo.png';
import dentox from "../assets/dentox.png";
import olivo from "../assets/olivo.png";
import rab from "../assets/rab.png";
import veta from "../assets/veta.png";
import agenda from "../assets/agenda.jpeg";
import arksuve from "../assets/arksuve.png";


const projects = [
  {
    num: '01',
    title: 'Pagina web - ARKSUVE',
    desc: 'Pagina web para empresa dedicada a la gestión y supervisión de proyectos de edificación e infraestructura en todo México.',
    image: arksuve,
    link: 'https://www.arksuve.com',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  }, {
    num: '02',
    title: 'ECOMMERCE - AYDE',
    desc: 'Ecommerce para empresa dedicada a la venta de arte',
    image: ayde,
    link: 'https://arteydisenoexclusivoayde.com',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  },
  {
    num: '03',
    title: 'Pagina web - SOLVINGEN',
    desc: 'Pagina web para empresa dedicada a la venta de equipos para la industria azucarera',
    image: solvingen,
    link: 'https://www.solvingen.com',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  },{
    num: '04',
    title: 'ECOMMERCE - BARLO JEWERLY',
    desc: 'E-commerce para empresa dedicada a la venta de joyeria.',
    image: barlo,
    link: 'https://barlojewelry.com',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  },
  {
    num: '05',
    title: 'LANDING PAGE - UPRAVIA',
    desc: 'Landing page para empresa dedicada a la administración de condominios, torres de departamentos y conjuntos residenciales.',
    image: upravia,
    link: 'https://www.upravia.com.mx',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  },
  {
    num: '06',
    title: 'LANDING PAGE - GESTORA - EN DESARROLLO',
    desc: 'Landing Page para Gestora, un CRM completo para PYMES con muchas funcionalidades para desarrollar tu negocio',
    image: gestora,
    link: '/',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" />
      </svg>
    ),
  },
  {
    num: '07',
    title: 'SISTEMA DE RESERVAS - ZENFLOW - EN DESARROLLO',
    desc: 'Software de gestión de reservas en la nube para agenda de clases especializadas.',
    image: agenda,
    link: '/',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  }, {
    num: '08',
    title: 'ECOMMERCE - ZAPATERIA RAB',
    desc: 'E-commerce para empresa dedicada a la venta de calzado para hombre y mujer.',
    image: rab,
    link: 'https://www.rab.com.mx',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  }, {
    num: '09',
    title: 'LANDING PAGE - PERLA Y OLIVO',
    desc: 'Landing page para empresa dedicada a la industria hotelera.',
    image: olivo,
    link: '/',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  }, {
    num: '10',
    title: 'LANDING PAGE - DENTOX',
    desc: 'Landing page para empresa dedicada a la salud dental.',
    image: dentox,
    link: 'https://dentox.mx',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  },  {
    num: '11',
    title: 'LANDING PAGE - VETA ARTESANAL',
    desc: 'Landing page para contructora',
    image: veta,
    link: 'https://vetaartesanal.com',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  },
];

const ProjectCard = ({ num, title, desc, icon, image, link }) => {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const rect = cardRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    cardRef.current.style.transform = `translateY(-8px) perspective(600px) rotateX(${y * -5}deg) rotateY(${x * 5}deg)`;
  };

  const handleMouseLeave = () => {
    cardRef.current.style.transform = 'translateY(0) perspective(600px) rotateX(0) rotateY(0)';
  };

  return (
    <div
      className="service-card reveal"
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <a href={link || '/'} target="_blank"
        rel="noopener noreferrer">
        <div className="service-card__image-container">
          <img 
            src={image || 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=1600&q=80'} 
            alt={`Vista previa del proyecto ${title}`} 
            className="service-card__image" 
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="service-card__number">{num}</div>
        <div className="service-card__icon">{icon}</div>
        <h3 className="service-card__title">{title}</h3>
        <p className="service-card__desc">{desc}</p>
        <button className="service-card__link" aria-label={`Ver detalles del proyecto ${title}`}>
          Ver detalles
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </a>
    </div>
  );
};

const Projects = () => {
  return (
    <section className="services" id="proyectos-lista" style={{ paddingTop: '10rem' }}>
      <div className="services__header reveal">
        <div className="section-label">Casos de Éxito</div>
        <h2 className="section-title">NUESTROS<br />PROYECTOS</h2>
        <div className="section-sub">
          Explora algunos de los trabajos más destacados que hemos realizado para empresas que buscan liderar en el mundo digital.
        </div>
      </div>
      <div className="services__grid">
        {projects.map((p) => (
          <ProjectCard key={p.num} {...p} />
        ))}
      </div>
    </section>
  );
};

export default Projects;
